'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _PictureAsPdf = _interopRequireDefault(require("@material-ui/icons/PictureAsPdf"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
_moment.default.locale('fr');
let app = window.app;
class CandidateList extends _react.Component {
  state = {
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    const company_id = app.state?.session?.user?.id;
    component.fetchCandidateAndCV(company_id);
  }
  fetchCandidateAndCV = company_id => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/cv/get-all-with-candidate', {
      company_id: company_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        cvs: response.cvs
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getSearchedContractLabel = searched_contracts => {
    let searched_contracts_label = (Object.keys(searched_contracts) || []).map(function (searched_contract) {
      let label;
      if (searched_contract === "alternance" && searched_contracts[searched_contract] === true) {
        label = "Alternance";
      } else if (searched_contract === "cdd" && searched_contracts[searched_contract] === true) {
        label = "CDD";
      } else if (searched_contract === "cdi" && searched_contracts[searched_contract] === true) {
        label = "CDI";
      } else if (searched_contract === "stage" && searched_contracts[searched_contract] === true) {
        label = "Stage";
      }
      return label + ' ';
    });
    return searched_contracts_label;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const user = app?.state?.session?.user;
    let list = (state.cvs || []).filter(cv => cv.is_public === true).map(function (cv) {
      let output = /*#__PURE__*/_react.default.createElement(_Link.default, {
        className: "c-candidate-list__item",
        href: "/candidats/" + cv.id
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "c-candidate-list__item__title"
      }, cv.title), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--orange"
      }, "Type de contrat : ", component.getSearchedContractLabel(cv.searched_contract_type)), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--blue"
      }, "Domaine professionnel : ", cv._professional_domain.label), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-categorie-view__description",
        dangerouslySetInnerHTML: {
          __html: cv.summary
        }
      }));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list"
    }, user?.roles[0] === "company" && user?.get_cv === true ? list : /*#__PURE__*/_react.default.createElement("p", null, "Nous avons \xE0 c\u0153ur de vous accompagner au mieux et cette fonction sera accessible une fois que nous aurons pris contact avec vous"));
    return output;
  }
}
exports.default = CandidateList;
